import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';

import BaiLogoLargeBlack from '@/assets/images/bai-logo-large-black.svg';
import BaiLogoLargeWhite from '@/assets/images/bai-logo-large-white.svg';

interface CenterLogoLayoutProps {
  children: React.ReactNode;
}

const CenterLogoLayout = ({ children }: CenterLogoLayoutProps) => {
  const theme = useTheme();
  const isLightMode = theme.palette.mode === 'light';

  return (
    <Box maxWidth={420} width='100%'>
      <Box textAlign='center' pb={5}>
        <img
          src={isLightMode ? BaiLogoLargeWhite : BaiLogoLargeBlack}
          alt='Biddable Assets Logo'
        />
      </Box>

      <Paper elevation={0} sx={{ p: 3 }}>
        {children}
      </Paper>
    </Box>
  );
};

export default CenterLogoLayout;
